import { getVideoPosition } from '~/Util/assets'
import { makeCancellable } from '~/Util/promise'
import { createKonvaShape } from './createKonvaShape'

export const createImages = (visibleAssets,
  refVideo, abortController, { scale, boundingRect, imageOverlayMaxSize }) => {
  const preparePositionsXY = [] // { assetId, id, videoPosition }
  const assetBlobs = [] // { assetId, blob }
  const imagePromises = visibleAssets
    .map(asset => createKonvaShape(asset, refVideo, { scale, boundingRect })
      .then(shape => {
        if (!shape) {
          return Promise.resolve()
        }

        const videoPosition = getVideoPosition({
          offset: asset.settings.offset,
          size: {
            width: shape.width(),
            height: shape.height(),
          },
          scale,
          boundingRect,
          rotation: asset.settings.rotation,
          outlineWidth: asset.settings.outlineWidth,
        })
        preparePositionsXY.push({ assetId: asset.id, videoPosition })

        // eslint-disable-next-line consistent-return
        const workPromise = new Promise((res, rej) => {
          shape.toCanvas().toBlob(img => {
            if (img.size > imageOverlayMaxSize) {
              rej(new Error('Too large image file. Max size is 10mb'))
            } else {
              assetBlobs.push({ assetId: asset.id, blob: img })
              res(img)
            }
          })
        })
        return makeCancellable(workPromise, abortController)
      }))
  return {
    imagePromises,
    assetBlobs,
    preparePositionsXY,
  }
}
